import { useSelector } from "react-redux"
const useCheckBlockPostCode = () => {
    const selectedStore= useSelector((state: any) => state?.store?.selectedStore);


    const IsBlockPostCode = (post_code: any) => {
        let block_post_code = selectedStore?.map_block_post_code?.block_delivery_postcode?.split(",");
        if (block_post_code?.length > 0) {
            return block_post_code?.some((i: any) => i?.toLowerCase()?.trim() == post_code?.toLowerCase()?.trim())
        }

        return false;
    }
    return IsBlockPostCode;
}

export default useCheckBlockPostCode;